import { Link } from "react-router-dom";
import { Facebook, Mail, Phone } from "lucide-react";
import { LOGO, NAV } from "../../lib/content";
import { telHref, useSite } from "../../context/SiteContext";
import { Sparkle, Tagline, TikTokIcon } from "./Decor";

const socialCls = "gold-trim grid h-11 w-11 place-items-center rounded-full text-[#D4A537] transition-colors duration-200 hover:bg-[#FF1F8E] hover:text-white";

export const SocialLinks = ({ className = "" }) => {
  const { contact } = useSite().site;
  return (
    <div className={`flex gap-3 ${className}`}>
      {contact.facebook && <a href={contact.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className={socialCls}><Facebook className="h-5 w-5" /></a>}
      {contact.tiktok && <a href={contact.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" data-testid="social-tiktok" className={socialCls}><TikTokIcon /></a>}
    </div>
  );
};

export const Footer = () => {
  const { contact, payments } = useSite().site;
  return (
  <footer className="relative overflow-hidden bg-[#0E0B0D] text-white" data-testid="site-footer">
    <div className="stitch-line" />
    <Sparkle className="absolute right-10 top-10" size={22} />
    <Sparkle className="absolute bottom-16 left-1/2" size={14} delay={1} />
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-[1.3fr_1fr_1fr]">
      <div>
        <div className="inline-block rounded-3xl bg-white p-3">
          <img src={LOGO} alt="KMK Customs Embroidery" className="h-20 w-auto" />
        </div>
        <Tagline className="mt-5 block text-3xl text-[#EBD08A]" />
        <p className="mt-3 max-w-sm text-sm text-white/65">Custom embroidery and apparel for families, schools, teams and businesses.</p>
      </div>
      <div>
        <p className="eyebrow mb-4 !text-[#D4A537]">Explore</p>
        <ul className="space-y-2.5 text-sm">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="text-white/75 transition-colors hover:text-[#FF1F8E]">{n.label}</Link></li>
          ))}
          <li><Link to="/order" className="font-semibold text-[#FF1F8E]" data-testid="footer-order-link">Start a Custom Order</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-4 !text-[#D4A537]">Get in touch</p>
        <a href={telHref(contact.phone)} className="flex items-center gap-3 py-1.5 text-white/85 hover:text-[#FF1F8E]" data-testid="footer-phone"><Phone className="h-4 w-4 text-[#D4A537]" />{contact.phone}</a>
        <a href={`mailto:${contact.email}`} className="flex items-center gap-3 break-all py-1.5 text-white/85 hover:text-[#FF1F8E]" data-testid="footer-email"><Mail className="h-4 w-4 shrink-0 text-[#D4A537]" />{contact.email}</a>
        <SocialLinks className="mt-5" />
        <p className="mt-6 text-xs text-white/50">We accept {payments.join(" · ")}</p>
      </div>
    </div>
    <div className="border-t border-white/10 px-6 py-5 text-center text-xs text-white/45">
      © {new Date().getFullYear()} KMK Customs Embroidery LLC · <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Owner login</Link>
    </div>
  </footer>
  );
};
